import React from 'react'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash'
import { checkIdtfFeatureEnabled } from 'configs'
import styles from './Forms.css'
import TextInput from '../../containers/Forms/components/TextInput'
import TextAreaInput from '../../containers/Forms/components/TextAreaInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import {
  emailMask,
  phoneNumberMask,
  getDateOfBirthMask,
  requiredValidation,
  dateValidation,
  emailValidation,
  phoneValidation,
  minLen1Validation,
  notesLenValidation,
  notJustSpacesValidation,
  validateMedantaUHIDCheck,
} from '../../containers/Forms/components/formValidations'
import { getName } from '../../containers/Utilities'
import RadioButton from '../../containers/Forms/components/RadioButton'
import { UNASSIGNED_ORDERING_PHYSICIAN_OPTION, FORM_SEX_OPTIONS, getDateOfBirthFormat } from '../../constants'
import SaveIcon from 'static/images/icons/content-save.svg'
import Loading from '../../components/Loading'
import { filterIsPhysicianPermission } from '../../store/appReducer'
import { IMPLANTED_DEVICES } from './constants'


const meTempObject = [
  {
    id: '11f1cad0-a9e2-4454-b4e1-41a902dd99b7',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'first_name',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: '0cac0d7c-6bff-45e9-bbde-10cf86442291',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'last_name',
    isRequired: false,
    isVisible: false,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: false,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: '12c24c92-4654-4a09-a6b7-99995726eaab',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'custom_participant_id',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: true,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: 'c858e14b-b088-4a52-894f-7254aad49ca3',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'email',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: '49f66fd4-b48d-44be-91bc-4e605490223a',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'sex',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: '9b1939bc-5e0e-43dd-81ad-ad2326c0d081',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'date_of_birth',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: 'a0ddbd13-7c59-4e59-9e1f-e71d44ba305d',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'ordering_physician_member_id',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: '6f754a10-0973-485d-a1fc-84efed68b55b',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'phone_number',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    id: 'a3303bad-ee22-437a-b5a3-dc61d4a5c621',
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'notes',
    isRequired: true,
    isVisible: true,
    isCustom: false,
    isKeyIdentifier: false,
    kardiaRXVisible: true,
    createdAt: '2021-08-30T23:02:11.025158Z',
    updatedAt: '2021-08-30T23:02:11.025158Z',
  },
  {
    teamId: 'SwKLID9U0wEAK5N5qZ0Nc7sc01mv1xj8',
    fieldName: 'middle_name',
    isRequired: true,
    isVisible: false,
    isCustom: true,
    isKeyIdentifier: false,
    kardiaRXVisible: false,
    createdAt: '2021-11-03T11:14:48.509366Z',
    updatedAt: '2021-11-03T11:14:48.509366Z',
  },
  {
    fieldName: 'secondary_phone_number',
    isKeyIdentifier: false,
    isRequired: true,
    isVisible: false,
    kardiaRXVisible: false,
    isCustom: true,
  },
]

const NewPatientForm = props => {
  const {
    handleSubmit,
    physicians,
    invalid,
    pristine,
    submitting,
    isSubmitting,
    medantaUHIDValidation,
    me,
  } = props

  const firstNameMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'firstName')
  const lastNameMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'lastName')
  const custom_participant_idMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'customParticipantID')
  const emailMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'email')
  const sexMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'sex')
  const date_of_birthMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'dob')
  const ordering_physician_member_idMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'orderingPhysicianMemberID')
  const phone_numberMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'phone')
  const notesMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'notes')

  const customFields = _.sortBy(me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.isCustom === true),
    [ o => o.displayName ])


  // get IDTF feature is enabled status
  const isIdtfEnabled = checkIdtfFeatureEnabled(me)

  let physicianOptions = [ UNASSIGNED_ORDERING_PHYSICIAN_OPTION ]

  if (physicians && physicians.data) {
    physicianOptions = [
      ...physicianOptions,
      ...filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id])),
    ]
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.formSection}>
        <div className={styles.formSectionRow}>
          {firstNameMe && firstNameMe.length > 0 &&
          <Field
            component={TextInput}
            label={firstNameMe[0].displayName}
            name="firstName"
            required={firstNameMe[0].isRequired}
            validate={firstNameMe[0].isRequired ? requiredValidation : ''}
            // required={isIdtfEnabled}
            // validate={isIdtfEnabled ? requiredValidation : ''}
          />
          }
          {lastNameMe && lastNameMe.length > 0 &&
          <Field
            component={TextInput}
            label={lastNameMe[0].displayName}
            name="lastName"
            required={lastNameMe[0].isRequired}
            validate={lastNameMe[0].isRequired ? requiredValidation : ''}
            // required={isIdtfEnabled}
            // validate={isIdtfEnabled ? requiredValidation : ''}
          />
          }
          <div className={styles.placeholder} />
        </div>
      </div>
      <div className={styles.formSection}>
        <div className={styles.formSectionRow}>
          {custom_participant_idMe && custom_participant_idMe.length > 0 &&
          <Field
            component={TextInput}
            label={custom_participant_idMe[0].displayName}
            name="customParticipantID"
            // required={true}
            // validate={[ requiredValidation, notJustSpacesValidation, validateMedantaUHIDCheck ]}
            required={custom_participant_idMe[0].isRequired}
            validate={custom_participant_idMe[0].isRequired ? [ requiredValidation, notJustSpacesValidation, validateMedantaUHIDCheck ] : ''}
          />
          }
          { emailMe && emailMe.length > 0 &&
          <Field
            component={MaskedInput}
            mask={emailMask}
            placeholder="name@example.com"
            label={emailMe[0].displayName}
            name="email"
            required={emailMe[0].isRequired}
            validate={emailMe[0].isRequired ? [ emailValidation, minLen1Validation, requiredValidation ] : ''}
            // required={!isIdtfEnabled}
            // validate={isIdtfEnabled ? [ emailValidation, minLen1Validation ] : [ emailValidation, minLen1Validation, requiredValidation ]}
          />
          }
          {sexMe && sexMe.length > 0 &&
            <Field
              component={ReactSelectDropdownInput}
              label={sexMe[0].displayName}
              name="sex"
              placeholder="Select a sex"
              options={FORM_SEX_OPTIONS}
              noOptionsMessage="No Sex found"
              getOptionLabel={p => p.label}
              getOptionValue={p => p.id}
            />
          }
        </div>
        <div className={styles.formSectionRow}>
          {date_of_birthMe && date_of_birthMe.length > 0 &&
            <Field
              component={MaskedInput}
              mask={getDateOfBirthMask(me)}
              placeholder={getDateOfBirthFormat(me)}
              label={date_of_birthMe[0].displayName}
              name="dob"
              validate={dateValidation}
              required={date_of_birthMe[0].isRequired}
            />
          }

          {ordering_physician_member_idMe && ordering_physician_member_idMe.length > 0 &&
            <Field
              component={ReactSelectDropdownInput}
              label={ordering_physician_member_idMe[0].displayName}
              name="orderingPhysician"
              isLoading={physicians && physicians.isFetching}
              isClearable={false}
              backspaceRemovesValue={false}
              placeholder="Unassigned"
              options={physicianOptions}
              noOptionsMessage="No provider found"
              getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
              getOptionValue={p => p.id}
            />
          }

          {phone_numberMe && phone_numberMe.length > 0 &&
            <Field
              component={MaskedInput}
              mask={phoneNumberMask}
              placeholder="XXX XXX-XXXX"
              label={phone_numberMe[0].displayName}
              name="phone"
              // required={isIdtfEnabled}
              // validate={isIdtfEnabled ? [ phoneValidation, requiredValidation ] : phoneValidation}
              required={phone_numberMe[0].isRequired}
              validate={phone_numberMe[0].isRequired ? [ phoneValidation, requiredValidation ] : phoneValidation}
            />
          }

        </div>
      </div>
      {/* Implanted Devices field only if IDTF feature is enabled */}
      {isIdtfEnabled &&
        <div className={styles.formSection}>
          <Field
            required
            component={RadioButton}
            label="Implanted Devices"
            name="implantedDevice"
            options={IMPLANTED_DEVICES}
            props={{ value: IMPLANTED_DEVICES }}
            validate={requiredValidation}
          />
        </div>
      }
      {
        customFields && customFields.length > 0 &&
        <div>
          <h2 className={styles.formTitle}>Custom Field</h2>
          <div className={styles.formSection}>
            <div style={{ display: 'block' }} className={styles.formSectionRow}>
              {customFields.map((item, i) => (
                item.isCustom &&
                <div style={i !== 0 ? { marginTop: 10 } : {}}>
                  <Field
                    component={TextInput}
                    label={item.displayName}
                    name={item.fieldName}
                    required={item.isRequired}
                    validate={item.isRequired ? requiredValidation : ''}
                  />
                </div>
              ))}
              <div className={styles.placeholder} />
            </div>
          </div>
        </div>
      }

      <div className={styles.formSection}>
        { notesMe && notesMe.length > 0 &&
        <Field
          component={TextAreaInput}
          label={notesMe[0].displayName}
          name="notes"
          validate={notesMe[0].isRequired ? notesLenValidation : ''}
          // validate={notesLenValidation}
        />
        }
      </div>
      <div className={styles.submitWrapper}>
        <div className={styles.buttonWrapper}>
          {submitting || isSubmitting ?
            <button disabled className={styles.submitLoading}>
              <Loading />
            </button>
            :
            <button type="submit" disabled={invalid || pristine} className={styles.submit}>
              <SaveIcon />
              Save
            </button>
          }
        </div>
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'newPatientForm',
})(NewPatientForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/NewPatientForm.jsx